import { render, staticRenderFns } from "./newmaterial.vue?vue&type=template&id=dd37b6ba&"
import script from "./newmaterial.vue?vue&type=script&lang=js&"
export * from "./newmaterial.vue?vue&type=script&lang=js&"
import style0 from "./newmaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports